import Axios from 'axios'
import { apiUrls, getParams, setAuthorizationHeaders, setHeaders } from '../utils'

const { newOOBaseUrl } = apiUrls

const latitude = 19.1213324
const longitude = 72.8703058

interface ProductsApiResponse<T = any> {
  data: T
  status: number
  statusText: string
  headers: any
  config: any
}

interface ProductApis {
  productDetail: (productId: string, storeId?: string) => Promise<ProductsApiResponse>
  // getCatApi: (productId: number) => Promise<ProductsApiResponse>
}

const productApis: ProductApis = {

  productDetail: async (productId: string, storeId?: string) => {
    const url = `${newOOBaseUrl}/search/store/product-details`
    const params: Record<string, any> = {
      latitude,
      longitude,
      productId: Number(productId)
    }

    if (storeId !== undefined && storeId !== null && storeId !== '') {
      params.storeId = Number(storeId)
    }

    return await Axios({
      url,
      method: 'GET',
      headers: setHeaders(setAuthorizationHeaders()),
      params: getParams(params)
    })
  }

}

export default productApis
